import React from "react";
import PropTypes from "prop-types";

const DisplayCell = (props) => {
  return <div dangerouslySetInnerHTML={{ __html: props.value }} />;
};

DisplayCell.propTypes = {
  value: PropTypes.node,
};

DisplayCell.defaultProps = {
  value: "",
};

export default DisplayCell;
